import styled, { ThemeProvider } from 'styled-components';
import { useState } from 'react';
import { getTheme, Theme } from './ui/theme';
import Feed from './components/Feed';

function App() {
  // const [test, setTest] = useStore(stores.clientConfig);

  const [theme,] = useState<Theme>(getTheme);

  return (
    <ThemeProvider theme={theme}>
      <Wrapper>


        <div className="feed-container">
          <Feed></Feed>
        </div>


      </Wrapper>
    </ThemeProvider >

  );
}

const Wrapper = styled.div`
/* background-color: ${props => props.theme.backgroundColor}; */
min-height: 100vh;
color: ${props => props.theme.font.default.color};
font-weight: ${props => props.theme.font.default.weight};
font-size: ${props => props.theme.font.default.size};

.feed-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding-bottom: 84px;
}

`

export default App;